<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Feed Bundle</ng-container>

    <ng-container dialog-process-in-progress
                  *ngIf="form && form.formGroup">
        <form [formGroup]="form.formGroup" class="row edit-feed-form">
            <div class="col-12">
                <span class="value pl-3 feed-subtitle">Available feeds</span>
            </div>

            <div class="col-12" *ngFor="let feed of form.controls, let i = index">
                <div class="d-flex align-items-center justify-content-between">
                    <p class="mb-0 col-6">
                        <app-checkbox
                            [control]="feed"
                            [formControlName]="feed.name"
                        >
                            <ng-container text>{{feed.placeholder|getFeedBundleNameAndPrice:0}}</ng-container>
                        </app-checkbox>
                    </p>
                    <p *ngIf="hasViewPricePermission"
                       class="mb-0 col-2 bundle-price">{{feed.placeholder|getFeedBundleNameAndPrice:1}}</p>
                    <p *ngIf="hasViewPricePermission"
                       class="mb-0 col-2 bundle-price">{{feed.placeholder|getFeedBundleNameAndPrice:2}}</p>
                    <p *ngIf="hasViewPricePermission"
                       class="mb-0 col-2">{{feed.placeholder|getFeedBundleNameAndPrice:3}}</p>
                    
                </div>
            </div>

        </form>
    </ng-container>

</app-dialog>
